import PropTypes from 'prop-types'

import { nodePropType } from '../../common/prop-types'

const brandPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  autoeatId: PropTypes.string,
  originalBrandId: PropTypes.string,
  name: PropTypes.string.isRequired,
  website: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  isPublished: PropTypes.bool,
  isDeleted: PropTypes.bool,
  isFake: PropTypes.bool,
  locationCount: PropTypes.number,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  mainLocationType: nodePropType,
  additionalLocationTypes: PropTypes.arrayOf(nodePropType),
  cuisineType: nodePropType,
  areLocationCuisineTypeAndLocationTypeSameAsBrand: PropTypes.bool,
})

brandPropType.defaultProps = {
  autoeatId: undefined,
  originalBrandId: undefined,
  isPublished: undefined,
  isDeleted: undefined,
  isFake: undefined,
  locationCount: undefined,
  createdAt: undefined,
  updatedAt: undefined,
  areLocationCuisineTypeAndLocationTypeSameAsBrand: undefined,
}

export default brandPropType
